// src/components/MachineRow.jsx
import React from 'react';
import MachineInfo from './MachineInfo';
import HoursRow from './HoursRow';
import styles from './MachineRow.module.css';

function MachineRow({ machine }) {
  return (
    <div className={styles.machineRow} data-machine-name={machine.name}>
      <MachineInfo machine={machine} mode={machine.mode} />
      <HoursRow hours={machine.hours} machine={machine} />
    </div>
  );
}

export default MachineRow;